import { observer } from 'mobx-react';
import React, { FC, ReactElement } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { modalStore } from '~/mobx/modalStore';
import ModalFooter from '~/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import './style.scss';
// eslint-disable-next-line max-len
import T360BranchesMappingTable from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360BranchesMapping/T360BranchesMappingTable/T360BranchesMappingTable';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';

export const T360BranchesMappingModal: FC = observer((): ReactElement => {
  const closeHandler = () => {
    modalStore.closeT360BranchesMappingModal();
  };

  const onApplyClicked = () => {
    if (modalStore.t360BranchesMappingModal?.duplicates && modalStore.t360BranchesMappingModal?.duplicates.size > 0) {
      modalStore.openNoticeModal({
        title: localeStore.t('matching_error'),
        message: localeStore.t('matching_error_popup_txt'),
        buttonText: localeStore.t('got_it'),
      });

      return;
    }

    const mappingModalStore = modalStore.t360BranchesMappingModal;

    if (!mappingModalStore) {
      return;
    }

    const settings = JSON.parse(JSON.stringify(t360IntegrationStore.integrationsSettingsTemp[mappingModalStore.integrationId] ?? {}));
    settings.settings.branches_mapping = mappingModalStore.mappedBranches ?? [];

    t360IntegrationStore.updateIntegrationSettingsTemp(mappingModalStore.integrationId, settings);

    modalStore.closeT360BranchesMappingModal();
  };

  return (
    <CustomModalComponent
      isOpen={Boolean(modalStore.t360BranchesMappingModal)}
      onRequestClose={closeHandler}
      withCloseIcon
      className="t360-screen-branches-mapping-modal"
    >
      <ModalBackground>
        <ModalHeader title={localeStore.t('branch_matching_title')} wrapperClassName="t360-branches-mapping-header" titleClassName="mb-1">
          <div className="family-medium text-size-14 color-gray2">{localeStore.t('keeta_branch_matching_txt')}</div>
        </ModalHeader>
        <T360BranchesMappingTable />
        <ModalFooter>
          <Button onClick={onApplyClicked}>{localeStore.t('apply')}</Button>
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});
